import { CashTypeEnum } from "./enums/CashTypeEnum";

export class Denomination {
    /** Valuta */
    public currency: string = null;

    /** Revisione */
    public revision: string = null;

    /** Taglio */
    public value: number = -1;

    /** Tipo banconota o moneta */
    public type: CashTypeEnum = CashTypeEnum.Unknown;

    constructor() {}

    public parse(obj: any) {
        if (obj.Currency) this.currency = obj.Currency;
        if (obj.Revision) this.revision = obj.Revision;
        if (obj.Value) this.value = obj.Value;
        if (obj.Type != null && Object.values(CashTypeEnum).includes(obj.Type)) this.type = obj.Type;
    }

    public clone(obj: Denomination) {
        this.currency = obj.currency;
        this.revision = obj.revision;
        this.value = obj.value;
        this.type = obj.type;
    }

    public isEquals(denomination: Denomination): boolean {
        return denomination.currency == this.currency && denomination.value == this.value && denomination.type == this.type;
    }

    public IsEqualsWithRevision(denomination: Denomination): boolean {
        return denomination.currency == this.currency && denomination.value == this.value && denomination.type == this.type && denomination.revision == this.revision;
    }

    public toString(): string {
        return this.value + " " + this.currency;
    }
}
